/**
 * Formats a number as a currency string.
 */
export const toMoney = (val, currency = 'EUR', locales = 'de-DE') => new Intl.NumberFormat(locales, { style: 'currency', currency }).format(val !== null && val !== void 0 ? val : 0);
/**
 * Formats a number as a decimal string.
 */
export const toDecimal = (val, locales = 'de-DE') => new Intl.NumberFormat(locales, { style: 'decimal', maximumSignificantDigits: 2 }).format(val !== null && val !== void 0 ? val : 0);
//# sourceMappingURL=money.js.map